import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { User } from '@ha/api/v2/types/User';

import { UserCardInfo } from 'ha/components/Redesign/UserCard';
import { Safeguard } from 'ha/components/Redesign/Safeguard';
import { units } from '@hbf/dsl';

const useStyles = makeStyles()(() => ({
  space: {
    margin: units.yx(1, 0),
    top: 0,
  },
}));

interface Props {
  hideNonFloatingSection?: boolean;
  isBelongsToPartner: boolean;
  user: User;
}

const ContactAdvertiserSection: React.FC<Props> = ({
  children,
  hideNonFloatingSection,
  isBelongsToPartner,
  user,
}) => {
  const { classes } = useStyles();
  const isPartnerListing = !hideNonFloatingSection && !isBelongsToPartner;

  return (
    <React.Fragment>
      {isPartnerListing && <UserCardInfo user={user} />}
      <div className={classes.space}>{children}</div>
      {isPartnerListing && <Safeguard />}
    </React.Fragment>
  );
};

export { ContactAdvertiserSection };
